module.exports = __webpack_public_path__ + "static/media/cupcakes2.0aa0ea28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/cupcakes2.jpg
// module id = 564
// module chunks = 0